import { createAction } from "@reduxjs/toolkit";
import { EcogardenObjects } from "../lib/objects";

export const addCopy = createAction<readonly EcogardenObjects[]>("ADD_COPY");
export const clearCopy = createAction<void>("CLEAR_COPY");
